import { useSpring } from '@react-spring/web'
import GroupRulesMd from 'assets/mds/Yephome-Group-Rules.md'
import * as S from 'components/GroundRulesPanel/styles'
import { useWindowSize } from 'hooks/useWindowSize'
import { useEffect, useMemo, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useModalOpen, useToggleGroundRules } from 'state/application/hooks'
import { ApplicationModal } from 'state/application/reducer'
import { useAppSelector } from 'state/hooks'
import { ExternalLink } from 'theme/components'

export default function GroundRules() {
  const currentUserInfo = useAppSelector((state) => state.user.userInfo)
  const open = useModalOpen(ApplicationModal.GROUNDRULES)

  const toggle = useToggleGroundRules()

  const [tosText, setTosText] = useState('')

  // Fetch Terms of Use
  useEffect(() => {
    fetch(GroupRulesMd)
      .then((res) => res.text())
      .then((text) => setTosText(text))
  }, [])

  const style = useSpring({
    from: { opacity: 0, display: 'none', transform: 'translate3d(104.39%,0,0)' },
    opacity: open ? 1 : 0,
    display: open ? 'flex' : 'none',
    transform: open ? 'translate3d(0%,0,0)' : 'translate3d(104.39%,0,0)',
    config: { duration: 200 }
  })
  const size = useWindowSize()
  const innerHeight = useMemo(() => {
    return size.clientHeight ? size.clientHeight - 46 : 0
  }, [size])
  return (
    <S.Panel style={style} innerheight={innerHeight} showall={currentUserInfo?.userId ? 0 : 1}>
      <S.CloseIcon onClick={toggle}>
        <S.CloseColor />
      </S.CloseIcon>
      <S.Content>
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            // eslint-disable-next-line react/display-name
            a: ({ ...props }) => <ExternalLink href="" {...props} />
          }}
        >
          {tosText}
        </ReactMarkdown>
      </S.Content>
    </S.Panel>
  )
}
